<template>
	<Layout pageTitle="Registrarme" :hideNavbar="true" :hideFooter="true">
		<div class="container">
			<div class="card">
				<div class="card-body">
					<router-link tag="a" to="/">
						<img src="https://cobraticket.uy/logo.svg" alt="" class="logo" />
					</router-link>
					<div class="form-box">
						<h3 class="mt-3">{{ $t("title") }}</h3>

						<div class="mt-3">
							<Register :redirectTo="redirectTo" />
						</div>

						<router-link class="btn btn-block btn-text mt-5" tag="a" :to="`/login`">
							{{ $t("alreadyRegistered") }}</router-link
						>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from "@/components/Layout"
import Register from "./Register"

export default {
	name: "RegisterPage",
	metaInfo() {
		return {
			title: this.$t("title")
		}
	},
	components: {
		Layout,
		Register
	},
	data() {
		return {
			redirectTo: this.$route.query.redirectTo || null
		}
	},

	i18n: {
		messages: {
			es: {
				title: "Crear cuenta en CobraTicket",
				alreadyRegistered: "¿Ya tienes cuenta? Ingresar"
			},
			en: {
				title: "Create account in CobraTicket",
				alreadyRegistered: "¿Ya tienes cuenta? Ingresar"
			},
			pt: {
				title: "Criar conta no CobraTicket",
				alreadyRegistered: "Você já tem uma conta? Ingresar"
			}
		}
	}
}
</script>

<style scoped lang="scss">
.container {
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;

	.card {
		width: 414px;
		text-align: center;
		padding-top: 32px;
		padding-bottom: 32px;

		.card-body {
			width: 100%;
			max-width: 85%;
			padding: 0px;
			margin: auto;

			h3 {
				font-size: 1.4rem;
			}
			.logo {
				width: 200px;
				margin-bottom: 30px;
				margin-bottom: 30px;
			}
		}
	}
}
</style>
